var map = {
	"./calme.png": "s83i",
	"./calme_shadow.png": "/CRR",
	"./content.png": "xs36",
	"./content_shadow.png": "cHXU",
	"./curieux.png": "TGY7",
	"./curieux_shadow.png": "RT6L",
	"./fache.png": "OWVS",
	"./fache_shadow.png": "ny0y",
	"./merveilleux.png": "6m3a",
	"./merveilleux_shadow.png": "zyAM",
	"./neutre.png": "bQ6c",
	"./neutre_shadow.png": "2eDO",
	"./surpris.png": "CyED",
	"./surpris_shadow.png": "398B",
	"./triste.png": "eh7s",
	"./triste_shadow.png": "3PMr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CntM";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions ^\.\/.*\.png$
// module id = CntM
// module chunks = 0